import { EnvironmentProviders } from '@angular/core';
import { userInitializerProvider } from './user.provider';
import { iconInitializerProvider } from '@app/utils/providers/icon.provider';
import { googleTagManagerInitializerProvider } from '@app/utils/providers/google-tag-manager.provider';

export const appInitializer: EnvironmentProviders[] = [
  userInitializerProvider,
  iconInitializerProvider,
  googleTagManagerInitializerProvider,
];
